"use strict";
import { jsx } from "react/jsx-runtime";
import { Router, Link } from "react-router";
function routeConfig({ path, component, onEnter, redirectTo }) {
  const paths = Array.isArray(path) ? path : [path];
  return paths.map((p) => ({
    path: p,
    component,
    onEnter: redirectTo ? (nextState, replace) => replace({
      pathname: redirectTo,
      query: nextState.location.query,
      state: nextState.location.state
    }) : onEnter
  }));
}
export default function LegacyRouter({
  history,
  layout,
  routes
}) {
  const configs = routes.flatMap(routeConfig);
  if (!layout) return /* @__PURE__ */ jsx(Router, { history, routes: configs });
  const indexRoute = configs.find((config) => config.path === "/");
  const childRoutes = configs.filter((config) => config !== indexRoute);
  return /* @__PURE__ */ jsx(
    Router,
    {
      history,
      routes: { path: "/", component: layout, indexRoute, childRoutes }
    }
  );
}
export { Link };
